interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  accent?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  accent = "primary",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  const accentClasses =
    accent === "accent"
      ? "bg-accent-100 text-accent-800"
      : accent === "secondary"
        ? "bg-secondary-100 text-secondary-800"
        : "bg-primary-100 text-primary-700";

  return (
    <div className={`${isCenter ? "text-center mx-auto" : ""} max-w-3xl mb-8 md:mb-12`}>
      <span
        className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-label font-medium tracking-wide ${accentClasses}`}
      >
        <span className="w-1.5 h-1.5 rounded-full bg-current"></span>
        {eyebrow}
      </span>
      <h2 className="mt-4 text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
        {title}
      </h2>
      {desc && (
        <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">{desc}</p>
      )}
    </div>
  );
}